
import { db } from './firebaseConfig';
import { doc, setDoc } from "firebase/firestore";

const CodigoEntregaDB = async ({ id, folio, codigo, nombre_out, correo_out, userAdd, userMod, fechaAdd, fechaMod, emp_id }) => {

    return await setDoc(doc(db, 'codigos', id), {
        folio: folio,
        codigo: codigo,
        nombre_out: nombre_out,
        correo_out: correo_out,
        useradd: userAdd,
        usermod: userMod,
        fechaadd: fechaAdd,
        fechamod: fechaMod,
        emp_id: emp_id
    })
}

export default CodigoEntregaDB;